import 'core-js/stable'
import 'regenerator-runtime/runtime'

// Suppress benign ResizeObserver loop notifications that CRA 5's dev overlay
// surfaces as an "Uncaught runtime error". These are emitted by browsers as a
// safety signal — they do not indicate a real error. We both (a) debounce the
// observer callback so the loop signal doesn't fire, and (b) swallow the
// matching error/rejection events as a belt-and-braces fallback.
if (typeof window !== 'undefined' && typeof window.ResizeObserver !== 'undefined') {
  const RESIZE_OBSERVER_MSGS = [
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ]
  const NativeResizeObserver = window.ResizeObserver
  window.ResizeObserver = class DebouncedResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let frame = 0
      super((entries, observer) => {
        if (frame) cancelAnimationFrame(frame)
        frame = requestAnimationFrame(() => callback(entries, observer))
      })
    }
  }
  const swallow = (e) => {
    const msg = (e && e.message) || (e && e.reason && e.reason.message)
    if (msg && RESIZE_OBSERVER_MSGS.some((m) => msg.includes(m))) {
      e.stopImmediatePropagation && e.stopImmediatePropagation()
      e.preventDefault && e.preventDefault()
      return false
    }
  }
  window.addEventListener('error', swallow)
  window.addEventListener('unhandledrejection', swallow)
}
